// src/views/NewJobStartView.js
// ───────────────────────────────────────────────────────────────────────────
// 🚦 Nuevo Trabajo — un solo punto de entrada que se despliega según el TIPO
// (PLAN-INTAKE-PRODUCTOS). Producto → intake rápido del catálogo; Servicio y
// Proyecto → formulario completo (NewJobView) con el tipo preseleccionado.
// UX: tarjetas con ícono referencial, color por tipo y affordance de acción.
// ───────────────────────────────────────────────────────────────────────────
import React from "react";
import { useNavigate } from "react-router-dom";
import { Package, Printer, Building2, Layers, ArrowRight } from "lucide-react";

const TYPES = [
  {
    key: "Producto",
    title: "Producto",
    desc: "Cajas, displays, banners, vinilos, stickers. Elige del catálogo y entuba en segundos.",
    Icon: Package,
    badge: "Reorden rápido",
    theme: {
      ring: "hover:ring-blue-500 hover:border-blue-500",
      badge: "bg-blue-100 text-blue-700",
      iconWrap: "bg-blue-100 text-blue-600",
      arrow: "text-blue-600",
    },
    go: "/jobs/new-lite",
  },
  {
    key: "Servicio",
    title: "Servicio",
    desc: "Impresión, corte, diseño, router, láser. Una operación facturable.",
    Icon: Printer,
    theme: {
      ring: "hover:ring-emerald-500 hover:border-emerald-500",
      badge: "bg-emerald-100 text-emerald-700",
      iconWrap: "bg-emerald-100 text-emerald-600",
      arrow: "text-emerald-600",
    },
    go: "/jobs/new/full?type=Servicio",
  },
  {
    key: "Proyecto",
    title: "Proyecto",
    desc: "Booths, eventos, trabajos custom de varias piezas. Abre el formulario completo.",
    Icon: Building2,
    theme: {
      ring: "hover:ring-amber-500 hover:border-amber-500",
      badge: "bg-amber-100 text-amber-700",
      iconWrap: "bg-amber-100 text-amber-600",
      arrow: "text-amber-600",
    },
    go: "/jobs/new/full?type=Proyecto",
  },
  {
    key: "GangRun",
    title: "Gang Run / Combo",
    desc: "Una hoja con piezas de varios trabajos/clientes. Producir-a-orden, con balanceo de ups.",
    Icon: Layers,
    theme: {
      ring: "hover:ring-fuchsia-500 hover:border-fuchsia-500",
      badge: "bg-fuchsia-100 text-fuchsia-700",
      iconWrap: "bg-fuchsia-100 text-fuchsia-600",
      arrow: "text-fuchsia-600",
    },
    go: "/jobs/new/gang",
  },
];

const NewJobStartView = () => {
  const navigate = useNavigate();
  return (
    <div className="max-w-4xl mx-auto p-2">
      <h1 className="text-3xl font-bold text-gray-800 mb-1">Nuevo Trabajo</h1>
      <p className="text-gray-500 mb-8">¿Qué vas a crear? El formulario se adapta al tipo que elijas.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {TYPES.map(({ key, title, desc, Icon, badge, theme, go }) => (
          <button
            key={key}
            onClick={() => navigate(go)}
            className={`group relative text-left p-6 rounded-2xl border border-gray-200 bg-white shadow-sm ring-1 ring-transparent transition-all duration-150 hover:-translate-y-1 hover:shadow-lg ${theme.ring}`}
          >
            {badge && (
              <span className={`absolute top-4 right-4 text-[11px] font-semibold px-2 py-0.5 rounded-full ${theme.badge}`}>
                {badge}
              </span>
            )}
            <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-4 ${theme.iconWrap}`}>
              <Icon size={28} strokeWidth={1.8} />
            </div>
            <div className="text-xl font-bold text-gray-800">{title}</div>
            <p className="text-sm text-gray-500 mt-1 leading-snug">{desc}</p>
            <div className={`mt-4 flex items-center gap-1 text-sm font-semibold ${theme.arrow}`}>
              Empezar
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default NewJobStartView;
